<template>
  <form ref="form" :key="link.url" @submit.prevent="onFormSubmit">
    <input type="hidden" name="campaign_id" :value="campaign.id">
    <input type="hidden" name="contact_id" :value="contactId">
    <input type="hidden" name="rendered_message_id" :value="renderedMessageId">
    <input type="hidden" name="link" :value="JSON.stringify(link)">
    <a :href="link.url"
      class="btn btn-block btn-lg mb-4"
      @click="saveActivity"
      target="_blank"
      :class="buttonClass(link.title)">
      <img v-if="link.logo !== undefined"
        :src="link.logo"
        class="review-item-img mr-2"
        alt="Logo">
      <img v-else
        :src="iconSelect(link.platform)"
        class="review-item-img mr-2"
        alt="Logo">
      <span>{{ link.title }}</span>
    </a>
  </form>
</template>

<script>
import axios from 'axios'
import { getIconUrl } from 'javascripts/common/review_platforms'

const BUTTON_CLASSES = {
  Facebook: 'btn-f-facebook',
  Google: 'btn-f-google'
}

export default {
  props: {
    link: { type: Object, required: true },
    campaign: { type: Object, required: true },
    contactId: { type: Number },
    renderedMessageId: { type: String },
    clickLink: { type: String, required: true }
  },
  methods: {
    buttonClass(linkTitle) {
      return BUTTON_CLASSES[linkTitle] || ''
    },
    iconSelect(platformTitle) {
      return getIconUrl(platformTitle)
    },
    saveActivity() {
      const options = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json'
        }
      }
      const data = new FormData(this.$refs.form)
      axios.post(this.clickLink, data, options)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~stylesheets/feedback_page/variables';
@import '~stylesheets/feedback_page/form';
@import '~stylesheets/feedback_page/page';
</style>
